import { useContext } from "react";
import { PointerCoordinatesContext } from "../state/contexts";

function usePointerCoordinates() {
  return useContext(PointerCoordinatesContext);
}

export default usePointerCoordinates;
